import { createContext, useMemo, type FC, type ReactNode } from "react";
import { User } from "../core/types";

export interface SupportAgentsContextType {
  supportAgents: User[];
}

export const SupportAgentsContext = createContext<SupportAgentsContextType | null>(null);

interface SupportAgentsProviderProps {
  children: ReactNode;
  supportAgents: User[];
}

export const SupportAgentsProvider: FC<SupportAgentsProviderProps> = ({ children, supportAgents }) => {
  const value = useMemo(() => ({ supportAgents }), [supportAgents]);

  return (
    <SupportAgentsContext.Provider value={value}>
      {children}
    </SupportAgentsContext.Provider>
  );
};
